var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('vue-apex-charts',{ref:"donutChart",attrs:{"type":"donut","height":"350","options":_vm.localOption,"series":_vm.localSeries}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }